import { Box, useMediaQuery, useTheme } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import GeneralDataSection from './GeneralDataSection';
import LocationDataSection from './LocationDataSection';

const BranchDialog = ({
  open,
  onClose,
  editMode,
  selectedBranch,
  onInputChange,
  onSave,
  companies = [],
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const commonProps = {
    selectedBranch,
    onInputChange,
    isMobile,
    editMode,
  };

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'fullWidth'}>
      <DialogTitle>{editMode ? 'Editar Sucursal' : 'Agregar Sucursal'}</DialogTitle>

      <DialogBody sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <GeneralDataSection {...commonProps} companies={companies} />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}

        <Box sx={{ flex: 1 }}>
          <LocationDataSection {...commonProps} />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default BranchDialog;
